import { render, staticRenderFns } from "./settingte.vue?vue&type=template&id=9b588f8a&scoped=true&"
import script from "./settingte.vue?vue&type=script&lang=js&"
export * from "./settingte.vue?vue&type=script&lang=js&"
import style0 from "./settingte.vue?vue&type=style&index=0&id=9b588f8a&lang=scss&scoped=true&"
import style1 from "./settingte.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b588f8a",
  null
  
)

export default component.exports